import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const TotalReservations = () => {
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/TotalReservations`, config)
            .then(response => {
                setTotal(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the total reservations:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#e2f0d9', color: '#2e7d32' }}>
                <i className="bi bi-calendar-check"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark">{total}</h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="total-reservations-tooltip"
                    data-tooltip-content="Celkový počet všetkých historických návštev a rezervácií evidovaných v celom systéme."
                >
                    Všetky rezervácie
                </span>
            </div>
            <Tooltip id="total-reservations-tooltip" place="top" effect="solid" />
        </div>
    );
};

export default TotalReservations;
